// 承載router-view的components
const Start = resolve => {
  import('components/start/start').then(module => {
    resolve(module);
  });
};

export default {
  path: '/intlPlaneTicket',
  component: Start,
  children: [
    {
      path: 'orderDetails',
      name: '国际机票订单详情',
      component: resolve =>
        require(['pages/intl-plane-ticket/order/order-details/order-details.vue'], resolve)
    },
    {
      path: 'refundDetails',
      name: '国际机票退票详情',
      component: resolve =>
        require(['pages/intl-plane-ticket/refund/refund-details/refund-details.vue'], resolve)
    },
    {
      // 国际机票询价单
      name: 'interPlaneTicketInquirySheet',
      path: 'inquirySheet',
      component: resolve => require(['pages/intl-plane-ticket/inquiry-sheet/apply.vue'], resolve)
    },
    {
      // 国际机票询价单列表
      name: 'intlPlaneTicketInquirySheetOrderList',
      path: 'inquirySheet/orderList',
      component: resolve => require(['pages/intl-plane-ticket/inquiry-sheet/order-list/order-list.vue'], resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: 'inquirySheet/orderDetails',
      name: '国际机票询价单详情',
      component: resolve => require(['pages/intl-plane-ticket/inquiry-sheet/order-details/order-details.vue'], resolve)
    },
    {
      path: 'inquirySheet/bookDetails',
      name: '国际机票询价单方案填写页',
      component: resolve => require(['pages/intl-plane-ticket/inquiry-sheet/book-details/book-details.vue'], resolve)
    },
    {
      path: 'inquirySheet/orderConfirm',
      name: '国际机票询价单方案确认页',
      component: resolve => require(['pages/intl-plane-ticket/inquiry-sheet/order-confirm/order-confirm.vue'], resolve)
    },
    {
      path: '*',
      redirect: '/home',
    },
  ]
}
